import {
  TemplateValidatorResponse,
  ValidateTemplateRequest,
  ValidateTemplateRequestItem,
} from "../../data-model/templateValidatorModel";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

/**
 * Validates business-office writeback templates via the batch validator endpoint.
 *
 * @param payload - Request items; sent wrapped under an `items` key.
 * @param signal - Optional abort signal to cancel the in-flight request.
 * @returns The validator response with per-item parsed content and scoring.
 * @throws {Error} When the endpoint responds with a non-OK status.
 */
export const validateTemplate = async (
  payload: ValidateTemplateRequestItem[],
  signal?: AbortSignal,
): Promise<TemplateValidatorResponse> => {
  const token = await getBearerToken();
  const requestBody: ValidateTemplateRequest = { items: payload };
  const response = await fetch(API_ENDPOINTS.TEMPLATE_VALIDATOR_VALIDATE, {
    method: "POST",
    body: JSON.stringify(requestBody),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Template validation failed: ${response.status} ${(errorData as { message?: string }).message || response.statusText}`,
    );
  }

  return response.json() as Promise<TemplateValidatorResponse>;
};
